<div class="selectors-container" *ngIf="configs">
  <div *ngFor="let config of configs" class="selector-wrapper">
    <label *ngIf="config.label" class="selector-label">{{ config.label }}</label>

    <ng-select
      [items]="config.options"
      bindLabel="title"
      bindValue="value"
      [(ngModel)]="values[config.key]"
      [multiple]="config.type === 'multi'"
      [clearable]="config.clearable"
      [searchable]="config.searchable"
      [closeOnSelect]="config.closeOnSelect"
      (change)="onChange(config.key, values[config.key])"
      class="selector"
      [ngClass]="config.type"
      >
      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        <div class="custom-selected">
          <span class="main-label" [title]="getDisplayValue(config).label">
            {{ getDisplayValue(config).label }}
          </span>
          <span *ngIf="getDisplayValue(config).remainingCount > 0" class="more-count">
            +{{ getDisplayValue(config).remainingCount }}
          </span>
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <span title="{{item.title}}">{{ item.title }}</span>
      </ng-template>
    </ng-select>
  </div>
</div>
